import React, { useEffect, useState } from "react";
import { getBanks } from "../../../../../api";
import config from "../../../../../config";
import CheckGreenCircleIcon from "../../../../assets/svg/icons/common/check-green-circle";
import FancyCheckbox from "../../../../components/form/fancy-checkbox";
import styles from "./style.module.scss";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import { useFormikContext } from "formik";
import baseStyles from "../../style.module.scss";
import useUserStore from "../../../../../v2/stores/user";

const Processors = ({ isOpen, onToggle }) => {
  const { values, setFieldValue, touched, handleBlur, handleChange } =
    useFormikContext();
  const isPCAdmin = useUserStore((state) => state.isPCAdmin);

  const [processorList, setProcessorList] = useState([]);
  const hasErrors =
    isPCAdmin &&
    ((values.based_on_mcc === false &&
      (!values.processors || values.processors.length === 0)) ||
      values.based_on_mcc === undefined);

  const handleProcessorsChange = (event, id) => {
    const { checked } = event.target;
    let updatedProcessors = [];

    if (checked) {
      updatedProcessors = [...values.processors, id];
    } else {
      updatedProcessors = values.processors.filter(
        (processorId) => processorId !== id,
      );
    }

    if (values.based_on_mcc && updatedProcessors.length > 0) {
      setFieldValue("based_on_mcc", false);
    }

    setFieldValue("processors", updatedProcessors);
  };

  useEffect(() => {
    const fetchProcessors = async () => {
      const response = await getBanks();
      if (response.status) {
        setProcessorList(response.data);
      }
    };
    fetchProcessors();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header} onClick={onToggle}>
        <div
          className={`${styles.header_left} ${baseStyles.headerLeft} ${isOpen && baseStyles.headerLeftOpen}`}
        >
          <CaretDown24 />
          <h6 className={styles.title}>Processor Selection</h6>
        </div>
        <div className={baseStyles.headerRight}>
          {!hasErrors && <CheckGreenCircleIcon />}
        </div>
      </div>

      {isOpen && (
        <div className={styles.content}>
          <div>
            <FancyCheckbox
              label={"Based on MCC"}
              id={"based_on_mcc"}
              name={"based_on_mcc"}
              checked={values.based_on_mcc}
              onChange={(event) => {
                if (event.target.checked) {
                  setFieldValue("processors", []);
                }
                setFieldValue("based_on_mcc", event.target.checked);
                handleChange(event);
              }}
              onBlur={handleBlur}
            />
          </div>

          {hasErrors && (touched.based_on_mcc || touched.processors) ? (
            <p className={styles.error}>
              Either select a processor or select Based on MCC
            </p>
          ) : (
            ""
          )}

          <h6 className={styles.separator}>OR</h6>

          <div className={styles.processorContainer}>
            {processorList.map((item, index) => (
              <FancyCheckbox
                key={index}
                ellipsis
                title={item.name}
                label={item.name}
                width={"100%"}
                icon={config.paymentcloud.STRATUS_URL + "bank-image/" + item.id}
                id={item.id}
                name={"processors"}
                checked={values?.processors.includes(item.id)}
                onChange={(event) => handleProcessorsChange(event, item.id)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Processors;
